import PropTypes from 'prop-types';
export var VERTICAL_ALIGNMENTS_PROP_TYPE = PropTypes.oneOf(['top', 'middle', 'bottom']);